// Auth route table — exported for App.js to mount under /auth/*.
// All routes below are public (no <RequireAuth /> wrapper).
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import MagicLinkSent from "@/pages/auth/MagicLinkSent";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import ResetRequest from "@/pages/auth/ResetRequest";
import ResetForm from "@/pages/auth/ResetForm";
import SessionExpired from "@/pages/auth/SessionExpired";
import TrialExpired from "@/pages/auth/TrialExpired";
import PurchasePlan from "@/pages/auth/PurchasePlan";
import PurchaseBasicRedirect from "@/pages/auth/PurchaseBasicRedirect";
import PaymentSuccess from "@/pages/auth/PaymentSuccess";
import PaymentCancelled from "@/pages/auth/PaymentCancelled";

export const authRoutes = [
  { path: "login",             element: <Login /> },
  { path: "signup",            element: <Signup /> },
  { path: "magic-link-sent",   element: <MagicLinkSent /> },
  { path: "verify-email",      element: <VerifyEmail /> },
  { path: "reset-request",     element: <ResetRequest /> },
  { path: "reset",             element: <ResetForm /> },
  { path: "session-expired",   element: <SessionExpired /> },
  { path: "trial-expired",     element: <TrialExpired /> },
  { path: "purchase-plan",     element: <PurchasePlan /> },
  { path: "purchase-basic",    element: <PurchaseBasicRedirect /> },
  { path: "payment-success",   element: <PaymentSuccess /> },
  { path: "payment-cancelled", element: <PaymentCancelled /> },
];
